import { z } from "zod";
import { Address } from "@clearabee/ui-sdk";
import { PostBasketRequest } from "@clearabee/ui-sdk";
import { postcode } from "lib/schemas";

type ValidationKeys = keyof NonNullable<PostBasketRequest["deliveryAddress"]>;

export type FieldsMap = Record<
  Exclude<ValidationKeys, "postcode" | "lat" | "lng">,
  keyof Address
>;

interface Prefix {
  prefix?: string;
}

export type AddressFieldValidationParams = Prefix &
  (
    | { field: string; condition: unknown }
    | { field?: undefined; condition?: undefined }
  );

export const addressValidation = {
  line1: z.union([z.string().min(1), z.number().transform(String)]),
  line2: z.union([z.string(), z.number().transform(String)]).optional(),
  city: z.string().min(1),
  county: z.string().optional(),
  postcode,
} as const;

export const addressInitialValues = {
  line1: "",
  line2: "",
  city: "",
  county: "",
  postcode: "",
};
